module.exports = __webpack_public_path__ + "static/media/iso.08b6bf10.svg";